export default "__VITE_ASSET__CUnbs$3B__";